import {CustomEventHandler} from "../utils/CustomEventHandler";
import {CUSTOM_SCROLL, isMobile} from "../common/globalVars";
import {HtmlUtil} from "../utils/HtmlUtil";

export default class MotionScrollProduct {
    constructor(targetEl) {
        this.targetEl = targetEl;
        this.init();
    }

    init() {
        this.addEvent();
    }

    addEvent() {
        this.onScrollHandler({detail:0});
        CustomEventHandler.addHandler(window, CUSTOM_SCROLL, (e)=>this.onScrollHandler(e));
        CustomEventHandler.addHandler(window, 'resize', (e)=>this.onResizeHandler(e));
        CustomEventHandler.addHandler(this.targetEl, 'transitionend', ()=> {
            this.onTransitionEndHandler();
        });
    }

    onScrollHandler(e) {
        if (isMobile(window.innerWidth)) {
            this.targetEl.classList.remove('onScroll');
            return;
        }

        let top = (HtmlUtil.getPos(this.targetEl).y - (e.detail + window.innerHeight*(1/3)));
        if (top < 0 ) {
            this.targetEl.classList.add('onScroll');
        } else {
            this.targetEl.classList.remove('onScroll');
        }

    }

    onResizeHandler() {
        if (isMobile(window.innerWidth)) {
            this.targetEl.classList.remove('onScroll');
        }
    }

    onTransitionEndHandler() {
        window.dispatchEvent(CustomEventHandler.polyfillEvent('resize'));
    }
}
